
import React from "react";
import KitchenDisplay from "@/components/Kitchen/KitchenDisplay";

const Kitchen = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <KitchenDisplay />
    </div>
  );
};

export default Kitchen;
